import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { SeoService } from '../../services/seo.service';
@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  @Output() outputEmiter = new EventEmitter<string>();
  @Output() numberEmiter = new EventEmitter<string>();

  public itsMobile = false;
  public video8: boolean;
  public path: string;
  public position: boolean;
  public active: any;
  public hide: any;

  ngOnInit(): void {
  }

  /* openVideo(number:any){
    this["video" + number] = true;
    if(number == '8'){
      const video = this.el.nativeElement.querySelector('video.main-video');
      video.play();
    }
  }

  closeVideo(number:any){
    this["video" + number] = false;
    if(number == '8'){
      const video = this.el.nativeElement.querySelector('video.main-video');
      video.pause();
    }
  } */

  me(): void {
    this.numberEmiter.emit("8");
  }

  onTabChanged() {
    this.outputEmiter.emit("8");
  }
}
